var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInitialBtnSym(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 23,
    viewBox: "0 0 10 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 8089"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.747958 4.84024L8.52106 11.0295C8.52106 11.0295 11.5193 8.64217 8.35381 6.1217C7.3746 5.34202 3.38746 2.16731 0.667969 0.00195312L0.747958 4.84024Z",
    fill: "#F05831"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0.747951 17.2185L8.52105 11.0293C8.52105 11.0293 11.5193 13.4166 8.35381 15.9371C7.37459 16.7167 3.38746 19.8914 0.667969 22.0568L0.747951 17.2185Z",
    fill: "#F05831"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInitialBtnSym);
export default __webpack_public_path__ + "static/media/initial-btn-sym.b73b56d33f88d1c981ec24c159d840b1.svg";
export { ForwardRef as ReactComponent };